import React, { useEffect, useState, useMemo } from 'react';
import { Form, Modal, Select } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { getLoadingZones } from '../api/publicRequests';

const API_URL = process.env.REACT_APP_API_URL;

const LoadingZoneSelect = () => {
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    const fetchZones = async () => {
      setLoading(true);
      const data = await getLoadingZones();
      if (mounted) {
        setZones(data);
        setLoading(false);
      }
    };
    fetchZones();
    return () => { mounted = false; };
  }, []);

  return (
    <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.SuLoadingZone !== currentValues.SuLoadingZone}>
      {({ getFieldValue }) => {
        const currentZoneId = getFieldValue('SuLoadingZone');
        const selectedZone = zones.find(z => z.Id === currentZoneId);
        
        // Find image if available
        let imageUrl = null;
        if (selectedZone && selectedZone.ZoneImage && selectedZone.ZoneImage.length > 0) {
          const imgData = selectedZone.ZoneImage[0];
          imageUrl = imgData.url ? `${API_URL}${imgData.url}` : null;
        }

        return (
          <div className="loading-zone-container">
            <Form.Item 
              name="SuLoadingZone" 
              label="Зона завантаження" 
              rules={[{ required: true, message: 'Оберіть зону' }]}
              style={{ marginBottom: imageUrl ? 12 : 24 }}
            >
              <Select 
                placeholder="Оберіть зону завантаження" 
                loading={loading}
                options={zones.map(z => ({ value: z.Id, label: z.Name }))} 
                suffixIcon={<DownOutlined />}
              />
            </Form.Item>

            {imageUrl && (
              <div className="loading-zone-preview fade-in">
                <div className="loading-zone-preview-label">Схема розвантаження</div>
                <img src={imageUrl} alt="Loading zone map" className="loading-zone-img" />
              </div>
            )}
          </div>
        );
      }}
    </Form.Item>
  );
};

export default LoadingZoneSelect;
